import './LandingPage.css';
import { useEffect, useState } from 'react';
import { Preferences } from '@capacitor/preferences';
import { useHistory, useLocation } from 'react-router';
import { useSnackbar } from 'notistack';
// import axios from 'axios';
// ICONs & SVGs
import logo from '../../imgs/final_logo.png'

function LandingPage() {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar()
  const location = useLocation();
  const [redirected, setRedirected] = useState(false); // New flag to track redirection

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const schoolId = searchParams.get('schoolId');
    const rolename = searchParams.get('for');
    const text = searchParams.get('text');

    
    if (schoolId) {
      handleSchoolId(schoolId,rolename,text);
    } else {
      if (!redirected) {
        setRedirected(true);  // Set flag to true
        enqueueSnackbar('School ID is not provided in the URL', { variant: 'error' });
        setTimeout(() => {
          history.push('/class-verification');
        }, 3000);
      }
    }
  }, []); 

  // useEffect(() => {
  //   // checkUserValidation();
  //   handleSchoolId();
  // }, [])

  const handleSchoolId = async (schoolId,rolename,text) => {
    if (schoolId) {
      const extractedSchoolId = schoolId.slice(4);

      // Check if the extracted part is not empty after removing the first 4 characters
      if (extractedSchoolId && rolename === 'parent') {
        // Store the remaining part as schoolId in Preferences
        await Preferences.set({ key: 'gjaai_user_schoolid', value: extractedSchoolId });
        if(rolename === 'parent'){
          await Preferences.set({ key: 'gjaai_role', value: rolename });
        }
        else{
          await Preferences.set({ key: 'gjaai_num10digit', value: false });
        }
        history.push('/signup');
      }else if (extractedSchoolId && text && rolename === 'student') {
        // Store the remaining part as schoolId in Preferences
        await Preferences.set({ key: 'gjaai_user_schoolid', value: extractedSchoolId });
        await Preferences.set({ key: 'gjaii_unique_text', value: text });
        if(rolename === 'student'){
          await Preferences.set({ key: 'gjaai_role', value: rolename });
        }else{
          await Preferences.set({ key: 'gjaai_num10digit', value: false });
        }
        history.push('/login');
      }else {
        enqueueSnackbar('Invalid School ID after extraction', { variant: 'error' });
        setTimeout(() => {
          history.push('/class-verification');
        }, 3000);
      }
      // Store schoolId in Preferences
      // await Preferences.set({ key: 'gjaai_user_schoolid', value: (schoolId) });
      // history.push('/login');
    } else {
      // Show error message if schoolId is missing and redirect after 3 seconds
      // console.error('School ID is not provided in the URL');
      enqueueSnackbar('School ID is not provided in the URL', { variant: 'error' });
      setTimeout(() => {
        history.push('/class-verification');
      }, 3000);
    }
  };
  // const checkUserValidation = async () => {
  //   const { value } = await Preferences.get({ key: 'gjaii_IDCARD_user' });
  //   if (value === 'undefined' || value === null) return setTimeout(() => history.push('/class-verification'), 3000);

  //   if (!!JSON?.parse(value)?.id) {
  //     // await axios.post(`${process.env.REACT_APP_BASE_URL}/user/getuser`, { id: JSON.parse(value)?.id })
  //     //   .then(async res => {
  //     //     if (res.data.success) {
  //     //       if (res.data.data[0].verification_status === 1) {
  //     //         if (res.data.data[0].role === 'student') {
  //     //           history.push("/home");
  //     //         } else {
  //     //           history.push("/teacher/home");
  //     //         }
  //     //       } else {
  //     //         history.push("/verification-status");
  //     //       }
  //     //     }
  //     //   })
  //     //   .catch(err => {
  //     //     console.log(err);
  //     //   })
  //     // if (JSON.parse(value).role === 'teacher') {
  //     //   setTimeout(() => history.push('/teacher/home'), 3000);
  //     // } else {
  //       // history.push("/home");
  //       setTimeout(() => history.push('/home'), 3000);
  //     // }
  //   } else {
  //     setTimeout(() => history.push('/class-verification'), 3000);
  //   }
  // }

  return (
    <div className='landing_page'>
      <img src={logo} alt="ID SOLUTIONS" />
    </div>
  )
}

export default LandingPage